import React, { useRef, useState, useEffect, useCallback } from "react";
import Tesseract from "tesseract.js";

const RealTimeTextRecognition = () => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Wrap startCamera with useCallback to avoid unnecessary recreation
  const startCamera = useCallback(async () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
          startRealTimeRecognition();
        }
      } catch (error) {
        console.error("Error accessing the camera:", error);
      }
    } else {
      alert("Camera not supported on this browser!");
    }
  }, []);

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach((track) => track.stop());
    }
  };

  const startRealTimeRecognition = () => {
    const interval = setInterval(() => {
      if (!isProcessing) {
        recognizeText();
      }
    }, 1500); // Process every 1.5 seconds

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  };

  const recognizeText = () => {
    if (canvasRef.current && videoRef.current) {
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");

      // Draw the current video frame on the canvas
      context.drawImage(
        videoRef.current,
        0,
        0,
        canvas.width,
        canvas.height
      );

      // Get the image data from the canvas
      const image = canvas.toDataURL("image/png");

      // Perform OCR using Tesseract.js
      setIsProcessing(true);
      setLoading(true);

      Tesseract.recognize(image, "eng", {
        logger: (info) => console.log(info),
      })
        .then(({ data: { text } }) => {
          setText(text); // Update the recognized text
          setLoading(false);
          setIsProcessing(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
          setIsProcessing(false);
        });
    }
  };

  // Use useEffect to start the camera on mount
  useEffect(() => {
    startCamera();

    return () => {
      stopCamera(); // Stop the camera on component unmount
    };
  }, [startCamera]); // Dependency added here

  return (
    <div>
      <h1>Real-Time Text Recognition</h1>
      <div>
        <video ref={videoRef} width="400" height="300" />
      </div>
      <canvas ref={canvasRef} width="400" height="300" style={{ display: "none" }} />
      <div>
        {loading ? (
          <p>Recognizing text...</p>
        ) : (
          <p><strong>Recognized Text:</strong> {text}</p>
        )}
      </div>
      <button onClick={stopCamera}>Stop Camera</button>
    </div>
  );
};

export default RealTimeTextRecognition;
